module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADIAQAAAAB6pOH4AAAAAnRSTlMAAQGU/a4AAAAzSURBVHgB7coxAQAACAMg+6e1gRbYsQBwM9dYTdM0TdMiTdM0TdM0TdM0TdM0TdM0TdMex4uITCQlppUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transparent.png
// module id = 2TjG
// module chunks = 0